<script setup>
  import { ref, watch, onMounted, watchEffect} from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useUserStore } from '@/stores/UserStore'
  import { useGoogleAnalyticsStore } from '@/stores/GoogleAnalyticsStore';
  import BaseModal from './base/BaseModal.vue';
  import { useToaster } from '@/composables/useToaster';

  const showModal = defineModel('showModal', { default: false });
  const emits = defineEmits(['close']);
  const props = defineProps({
    profileId: {
      type: Number,
      required: false
    },
    show: {
      type: Boolean,
      default: false
    },
  });

  const userStore = useUserStore();
  const googleAnalyticsStore = useGoogleAnalyticsStore();
  const toaster = useToaster();

  const { t } = useI18n();

  const profileName = ref(``);

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function handleDeleteProfile() {
    if (userStore.currentProfileId === props.profileId) {
      userStore.setDefaultProfile(userStore.userProfiles.profiles[0].profile_id);
    }

    await userStore.deleteProfile(props.profileId);

    googleAnalyticsStore.sendEvent('User_Profile_Delete');

    await userStore.getProfiles(true);

    toaster.toast({
      type: 'success',
      content: t('profiles.deletedToast', { name: profileName.value })
    })

    closeModal();
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  });

  watch(() => props.profileId, () => {
    profileName.value = userStore.getProfileById(props.profileId).name;
  }, { immediate: true });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
    @close="closeModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">{{ t('profiles.deleteTitle') }}</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <p class="jwx-modal__text">{{ t('profiles.deleteConfirm') }}<br><strong>{{ profileName }}</strong>?</p>
      </div>
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          {{ t('common.cancel') }}
      </button>
        <button 
          type="button" 
          @click.prevent="handleDeleteProfile"
          class="jwx-button jwx-button--danger"
        >
          {{ t('common.delete') }}
        </button>
      </div>
    </div>
  </BaseModal>
</template>